import { ItcCustomSelect } from "../../../js/global/modules/custom-select";

class TextInnerSelector {
    constructor(selectors) {
        this.selectors = selectors;

        this.selects = [];
        this.bodys = [];

        this._init();
    }

    _init() {
        this.selectors.forEach((selector) => {
            selector.style.marginBottom = "0";
        });

        this._prepareSelects();

        this.bodys.forEach((body) => {
            body.style.marginBottom = "24px";
        });

        this._initSelector();
        this._initSelectorListener();
        this._showElement(this.bodys[0]);
    }

    _prepareSelects() {
        this.selectors.forEach((selector) => {
            const title = selector.querySelector(".js-text-inner-selector-title");
            const body = selector.querySelector(".js-text-inner-selector-body");

            if (title && body) {
                this.selects.push(title.innerHTML);
                this.bodys.push(body);

                this._hideElement(title);
                this._hideElement(body);
            }
        });
    }

    _initSelector() {
        const selectNest = document.createElement("div");
        const select = document.createElement("select");

        selectNest.classList.add("text-inner__custom-select", "custom-select");
        selectNest.setAttribute("data-custom-select", "");
        select.setAttribute("data-select", "target");

        this.selects.forEach((title, i) => {
            const option = document.createElement("option");

            option.value = i;
            option.innerHTML = title;
            select.appendChild(option);
        });

        selectNest.appendChild(select);
        this.selectElement = selectNest;

        this.selectors[0].before(selectNest);

        new ItcCustomSelect(selectNest);
    }

    _initSelectorListener() {
        if (!this.selectElement) return;

        this.selectElement.addEventListener("change", (e) => {
            const target = e.target;
            const body = this.bodys[target.value];

            this.bodys.forEach((body) => {
                this._hideElement(body);
            });

            this._showElement(body);
        });
    }

    _hideElement(target) {
        target.classList.add("hidden");
    }

    _showElement(target) {
        target.classList.remove("hidden");
    }
}

const selectors = document.querySelectorAll(".js-text-inner-selector-init");

if (window.mobileMedia && selectors && selectors.length > 1) {
    window.addEventListener("load", () => {
        new TextInnerSelector(selectors);

        ItcCustomSelect.hideOpenSelect();
    });
}
